export default {
  newDesign: true,
  parameters: {
    landing_id: "BrQzPrS",
    segment: 42,
  },
  title: "Ajude seu filho a desenvolver hoje habilidades que se transformarão em renda real amanhã | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Obrigado por confiar em nossa plataforma educacional!",
    subtitle:
      "Infelizmente, tablets ou telefones não são adequados para assistir às nossas aulas. Ficaremos felizes em vê-lo em nossas aulas na próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "¿Cuántos años tiene tu hijo?",
      image: {
        url: "/welcome/br_profit_skills_desk.png",
      },
      imageMobile: {
        url: "/welcome/br_profit_skills_mob.png",
      },
    },
    2: {
      question:
        "¿Qué te resulta más atractivo al aprender programación?",
      answers: [
        "🚀 La oportunidad de tener un ingreso alto en el futuro",
        "💵 La posibilidad de ganar su primer dinero",
        "🧠 Desarrollar lógica y disciplina",
        "✅ Todas las anteriores"
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_profit.png",
      subtitle:
        "«Los adolescentes que comienzan a programar antes de los 18 años tienen el doble de probabilidades de construir una carrera tecnológica exitosa y obtener mayores ingresos en el futuro»<br><br><i>Fuente: Investigación del MIT, Early STEM Education</i>",
      button: "¡Genial!",
    },
    4: {
      question: "¿Cuáles son los principales intereses de tu hijo/a?",
      answers: [
        "🎨 Creatividad y arte",
        "🎮 Videojuegos y gaming",
        "🐾 Animales y naturaleza",
        "⚽ Deportes y actividades físicas",
        "📚 Lectura y aprender cosas nuevas",
        "🤖 Ciencia y tecnología",
      ],
    },
    5: {
      question:
        "¿Tu hijo/a tiene acceso a una computadora o laptop para las clases en línea?",
      answers: [
        "💻 Si",
        {
          answer: "😐 No",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    7: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "A aula vai acontecer na nossa plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Você vai receber um link e um código único pelo WhatsApp e e-mail. Basta clicar no link, ele vai te levar direto para a aula. Sem aplicativos extras, sem downloads.",
      button: "Entendi ✅",
    },
  },
};
